import { createRouter, createWebHistory } from 'vue-router'
import app from '@/app.js'
import multiguard from 'vue-router-multiguard';
import {
  redirectUnauthenticated,
  redirectAuthenticated,
  redirectUnauthorized,
  redirectFromIndex,
} from './traps';

// routes
import auth from './routes/auth';
import siteMessages from './routes/siteMessages';
import billing from './routes/billing';
import businessUsers from './routes/businessUsers';
import businesses from './routes/businesses';
import cannedReplies from './routes/cannedReplies';
import contracts from './routes/contracts';
import creatorProgram from './routes/creatorProgram';
import events from './routes/events';
import grooveWidget from './routes/grooveWidget';
import home from './routes/home';
import internalUsers from './routes/internalUsers';
import invoices from './routes/invoices';
import labels from './routes/labels';
import networkReview from './routes/networkReview';
import notFound from './routes/notFound';
import packages from './routes/packages';
import payments from './routes/payments';
import pins from './routes/pins';
import promotions from './routes/promotions';
import reports from './routes/reports';
import scheduledThreads from './routes/scheduledThreads';
import sponsorships from './routes/sponsorships';
import threads from './routes/threads';
import tracking from './routes/tracking';
import users from './routes/users';
import terms from './routes/terms';
import verifyLink from './routes/verifyLink';
import { nextTick } from 'vue';

const router = createRouter({
  history: createWebHistory('/'),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
  routes: [
    ...auth,
    ...billing,
    ...businesses,
    ...businessUsers,
    ...cannedReplies,
    ...contracts,
    ...creatorProgram,
    ...events,
    ...grooveWidget,
    ...home,
    ...internalUsers,
    ...invoices,
    ...labels,
    ...networkReview,
    ...packages,
    ...payments,
    ...pins,
    ...promotions,
    ...reports,
    ...scheduledThreads,
    ...siteMessages,
    ...sponsorships,
    ...threads,
    ...terms,
    ...tracking,
    ...users,
    ...verifyLink,
    ...notFound,
  ],
});

if (process.env.NODE_ENV !== 'test') {
  router.app = app;
}

// configure traps
router.beforeEach(
  multiguard([
    redirectUnauthenticated,
    redirectAuthenticated,
    redirectUnauthorized,
    redirectFromIndex,
  ]),
);

// set the title of the page
const DEFAULT_TITLE = 'Pepper Business';
router.afterEach((to, from) => {
    nextTick(() => {
        const viewTitle = to.meta.title;
        document.title = viewTitle ? `${viewTitle} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;
    });
});

if (!app.config.globalProperties.$router) {
  app.use(router);
}

export default router;
